import api from './api.service';

type ApiBody<T> = { success?: boolean; data?: T; message?: string };

async function unwrap<T>(promise: Promise<unknown>): Promise<T> {
  const body = (await promise) as ApiBody<T>;
  if (body?.data === undefined) {
    throw new Error(body?.message || 'Automation request failed');
  }
  return body.data;
}

export const automationService = {
  getMonitor: () => unwrap<Record<string, unknown>>(api.get('/automation/monitor')),
  getRuntime: () => unwrap<Record<string, unknown>>(api.get('/automation/runtime')),
  listPlaybooks: () => unwrap<unknown[]>(api.get('/automation/playbooks')),
  createPlaybook: (payload: Record<string, unknown>) =>
    unwrap<unknown>(api.post('/automation/playbooks', payload)),
  getDesigner: () => unwrap<Record<string, unknown>>(api.get('/automation/designer')),
  listEvents: () => unwrap<unknown[]>(api.get('/automation/events')),
  emitEvent: (payload: {
    eventType: string;
    idempotencyKey?: string;
    payload?: Record<string, unknown>;
    entityType?: string;
    entityId?: string;
  }) => unwrap<unknown>(api.post('/automation/events', payload)),
  listExecutions: (status?: string) =>
    unwrap<unknown[]>(
      api.get('/automation/executions', { params: status ? { status } : undefined })
    ),
  getExecution: (id: string) =>
    unwrap<Record<string, unknown>>(api.get(`/automation/executions/${id}`)),
  resume: (id: string, payload?: Record<string, unknown>) =>
    unwrap<unknown>(api.post(`/automation/executions/${id}/resume`, { payload })),
};
